// extracted by mini-css-extract-plugin
export default {"root":"Link_root__FMM5+","small":"Link_small__hTwjH","medium":"Link_medium__d3hNK"};